import React, { useEffect, useState } from "react";
import { Phone } from "lucide-react";

export default function CallNowButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="tel:6138222333"
      data-testid="sticky-call-now"
      aria-label="Call Premium Auto Works at (613) 822-2333"
      className={`fixed z-50 bottom-5 right-5 sm:bottom-7 sm:right-7 flex items-center gap-2.5 px-4 sm:px-5 py-3 sm:py-3.5 rounded-full bg-[#F5C518] hover:bg-[#FFD642] text-[#121212] font-display font-bold uppercase tracking-wider text-xs sm:text-sm shadow-[0_8px_30px_rgba(245,197,24,0.35)] hover:shadow-[0_0_30px_rgba(245,197,24,0.6)] transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <span className="relative flex w-7 h-7 sm:w-8 sm:h-8 items-center justify-center rounded-full bg-[#121212]/15">
        <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={2.5} fill="currentColor" />
        <span className="absolute inline-flex w-full h-full rounded-full bg-[#121212]/20 animate-ping" />
      </span>
      <span className="hidden xs:inline sm:inline">Call Now ·</span>
      <span className="tabular-nums">(613) 822-2333</span>
    </a>
  );
}
